import { concatClasses } from "../../../helpers/concatClasses/index.js";
const navbarClasses = ({ dsf_mobile }) => {
  const classes = ["flex", "flex-col", "bg-neutral-0"];
  if (dsf_mobile) {
    classes.push("min-w-240", "h-full");
  }
  return concatClasses(classes);
};
const navbarWrapperClasses = ({ dsf_mobile, dsf_collapsed }) => {
  const classes = ["flex", "flex-row", "items-center", "gap-24"];
  if (dsf_mobile) {
    classes.push("dsf-pb-m", "w-full", "dsf-pt-l", "border-b-1", "border-neutral-100");
  } else {
    classes.push("pb-0");
  }
  if (dsf_collapsed) {
    classes.push("justify-center", "dsf-px-s", "dsf-mb-l", "dsf-pt-l");
  } else {
    classes.push("justify-between", "dsf-px-l", "dsf-mb-s", "dsf-pt-xl");
  }
  return concatClasses(classes);
};
const logoClasses = ({ dsf_collapsed }) => {
  const classes = ["outline-none", "text-left"];
  if (dsf_collapsed) {
    classes.push("self-center");
  }
  return concatClasses(classes);
};
const slotContainerClasses = ({ dsf_mobile, dsf_collapsed }) => {
  const classes = ["w-full", "flex", "flex-col"];
  if (dsf_collapsed) {
    classes.push("gap-2", "dsf-p-s");
  } else {
    classes.push("gap-10", "dsf-p-l");
  }
  if (dsf_mobile || !dsf_collapsed) {
    classes.push("overflow-y-auto");
  }
  return concatClasses(classes);
};
const collapseButtonClasses = ({ dsf_collapsed }) => {
  const classes = ["mt-auto", "w-full"];
  if (dsf_collapsed) {
    classes.push("dsf-p-s");
  } else {
    classes.push("dsf-p-l");
  }
  return concatClasses(classes);
};
export {
  collapseButtonClasses,
  logoClasses,
  navbarClasses,
  navbarWrapperClasses,
  slotContainerClasses
};
